<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				{{ holiday.name }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md4>
						{{ $t("label.email") }}: {{ holiday.email }}
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["holiday"],
};
</script>